import { hostBridge } from '@publicala/delfino';
import type { FullscreenChangedPayload } from '@publicala/delfino';
import type { VuexStore } from '../types';

let uiStore: VuexStore | null = null;

/**
 * Configure dependencies for UI commands.
 *
 * @param store - Vuex store
 */
export function configureUICommands(store: VuexStore): void {
    uiStore = store;
}

/**
 * Register UI commands that Volpe implements.
 * The Host calls these methods.
 */
export function registerUICommands(): void {
    if (!uiStore) {
        console.warn('[UICommands] store not configured. Call configureUICommands first.');
        return;
    }

    const store = uiStore;

    hostBridge.registerUICommands({
        /**
         * Mirrors a fullscreen change the host made on its own (the user pressing Esc, or an
         * exit the OS forced). The host also sends it right after connect or reconnect, so the
         * reader starts from the state actually on screen.
         *
         * @param payload - Current fullscreen state on the host
         */
        fullscreenChanged: async (payload: FullscreenChangedPayload): Promise<void> => {
            store.dispatch('updateFullscreenState', payload.isFullscreen);
        },
    });
}
